import { Popconfirm, Select, Space, Tooltip } from 'antd'
import { Button, ButtonActionBar, Typography } from 'modules/core/components'
import { generateSelectOptions } from 'modules/core/utils'
import { useCooldown } from 'modules/core/customHooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ActionBar = (props) => {
  const {
    rdnDefault,
    rdnOptions,
    handleRdnChange,
    onApplyConfirmPopConfirm,
    onUnApplyConfirmPopConfirm,
    hasApplyOrUnApply,
  } = props
  const { t } = useTranslation()
  // Blocks both buttons (apply and unapply) for 1 minute after executing the business rule
  const { isCoolingDown, startCooldown } = useCooldown()

  return (
    <ButtonActionBar position="space-between">
      <Space direction="horizontal">
        <Typography.Body>{t('LABEL_BUSINESS_RULES')}:</Typography.Body>
        <Select
          style={{ width: 300 }}
          value={rdnDefault}
          placeholder={t('LABEL_BUSINESS_RULES')}
          options={generateSelectOptions({ options: rdnOptions })}
          onChange={handleRdnChange}
        />
      </Space>
      <Space>
        <Tooltip title={isCoolingDown ? t('BUSINESS_RULES_COOLDOWN_TOOLTIP_TITLE') : ''}>
          <span>
            <Popconfirm
              placement="bottomRight"
              title={
                <div style={{ width: 300 }}>
                  {t('PLANNING_PHASES_ACTION_CONFIRM_POPCONFIRM_TITLE')}
                </div>
              }
              onConfirm={() => {
                startCooldown()
                onApplyConfirmPopConfirm()
              }}
            >
              <Button.Primary title={'Aplicar'} disabled={hasApplyOrUnApply || isCoolingDown} />
            </Popconfirm>
          </span>
        </Tooltip>
        <Tooltip title={isCoolingDown ? t('BUSINESS_RULES_COOLDOWN_TOOLTIP_TITLE') : ''}>
          <span>
            <Popconfirm
              placement="bottomRight"
              title={
                <div style={{ width: 300 }}>
                  {t('PLANNING_PHASES_ACTION_CONFIRM_POPCONFIRM_TITLE')}
                </div>
              }
              onConfirm={() => {
                startCooldown()
                onUnApplyConfirmPopConfirm()
              }}
            >
              <Button.Primary title={'Desaplicar'} disabled={hasApplyOrUnApply || isCoolingDown} />
            </Popconfirm>
          </span>
        </Tooltip>
      </Space>
    </ButtonActionBar>
  )
}

export default ActionBar
